import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';

import { UserCreateInput, UserListResponse, UserResponse, UserResiliationResponse, UserSelectInput, UserUpdateInput } from '@repo/types';
import { BaseApiService } from './base-api.service';

export class UserService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.USERS.BASE, axios);
  }

  async getUsers(filters: UserSelectInput): Promise<UserListResponse> {
    const { page = 1, limit = 10, ...rest } = filters;
    return this.getPaginated({ page, limit, ...rest });
  }

  async getUserById(id: number): Promise<UserResponse> {
    return this.get<UserResponse>(`/${id}`);
  }

  async createUser(data: UserCreateInput): Promise<UserResponse> {
    return this.post<UserResponse, UserCreateInput>('', data);
  }

  async updateUser(id: number, data: UserUpdateInput): Promise<UserResponse> {
    return this.put<UserResponse, UserUpdateInput>(`/${id}`, data);
  }

  async deleteUser(id: number): Promise<UserResponse> {
    return this.delete<UserResponse>(`/${id}`);
  }

  async getUserProfile(): Promise<UserResponse> {
    return this.get<UserResponse>('/profile');
  }

  async updateUserProfile(userId: number, profilId: number): Promise<string> {
    return this.post<string>('/profile/update-profil', { userId, profilId });
  }

  async updateUserProfileById(userId: number, profilId: number): Promise<string> {
    return this.post<string>(`/${userId}/update-profil`, { profilId });
  }

  async adminChangePassword(userId: number, newPassword: string, passwordConfirm: string): Promise<void> {
    return this.patch<void>(`/${userId}/admin-change-password`, {
      newPassword,
      passwordConfirm,
    });
  }

  async changeSelfPassword(currentPassword: string, newPassword: string, passwordConfirm: string): Promise<void> {
    return this.post<void>(`/me/change-password`, {
      currentPassword,
      newPassword,
      passwordConfirm,
    });
  }

  async uploadAvatar(userId: number, file: File): Promise<string> {
    const formData = new FormData();
    formData.append('avatar', file);
    console.log(userId);

    const response = await this.axios.post(`${ENDPOINTS.USERS.PROFILE}/avatar`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data.avatarUrl;
  }

  async uploadAvatarById(userId: number, file: File): Promise<string> {
    const formData = new FormData();
    formData.append('avatar', file);

    const response = await this.axios.post(`${ENDPOINTS.USERS.BY_ID(userId.toString())}/avatar`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data.avatarUrl;
  }

  async activateUser(id: number): Promise<UserResponse> {
    return this.put<UserResponse>(`/${id}/activate`);
  }

  async deactivateUser(id: number): Promise<UserResponse> {
    return this.put<UserResponse>(`/${id}/desactivate`);
  }

  async resiliateUser(id: number): Promise<UserResiliationResponse> {
    return this.post<UserResiliationResponse>(`/${id}/resiliation`, {});
  }

  async deleteMyAccount(): Promise<UserResponse> {
    return this.delete<UserResponse>('/me');
  }

  async resiliateMyAccount(): Promise<UserResiliationResponse> {
    return this.post<UserResiliationResponse>('/me/resiliation', {});
  }
}
